import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from '../pages/Home';
import Projetos from '../pages/projetos';
import Erro from '../pages/Erro';

export default function RoutesApp() {
    return(

        <BrowserRouter>
            <Routes>
                <Route path='/' element= { <Home /> }/>
                <Route path='/projetos' element= { <Projetos /> } />
                <Route path='*' element={ <Erro /> }/>
            </Routes>
        </BrowserRouter>

    );
}